<template>
  <el-container>
    <div class="articleDiv" id="SearchArticleDiv">
      <el-row>
        <el-header class="header-article">
          <el-row class="articleRow">
            <div class="articleLabel articleFirstLable">
              <label>{{ articleId }}</label>
            </div>
            <div class="articleNews">
              <span class="article-top articleTitle" tabindex="1">{{ articleTitle }}</span>
            </div>
          </el-row>
        </el-header>
      </el-row>
      <el-row>
        <el-main>
          <div class="commentRow">
            <ul class="logoArtInfo">
              <li class="article-first-child" v-if="articleDataSection == 1">
                <div class="article-img">
                  <img src="../../assets/image/logo-new.png" alt="LOGO" />
                </div>
              </li>
              <li class="article-first-child" v-else-if="articleDataSection == 2">
                <div class="article-img">
                  <img src="../../assets/image/Nikkie-logo-web.svg" alt="LOGO" />
                </div>
              </li>
              <li class="article-second-child">
                <div class="article-list">
                  <ul class="articleSpec">
                    <li v-if="articleCategory != ''">
                      <span class="articleSpan">{{ articleCategory }}</span>
                    </li>
                    <li v-if="articleDate != ''">
                      <span class="articleSpan">{{ articleDate }}</span>
                    </li>
                    <li v-if="articlePages != ''">
                      <span class="articleSpan">{{ articlePages }}</span>
                    </li>
                     <li v-if="articleSearchTerm != ' ' && articleSearchTerm != ''">
                      <span class="articleSpan">{{ articleSearchTerm }}</span>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="article-third-child">
              </li>
            </ul>
          </div>
        </el-main>
      </el-row>
      <el-divider class="article-main-divider"></el-divider>
      <el-footer>
        <div class="ariticle-bottom">
          <ul v-if="articleComment != '' && articleComment != null">
            <li>
              <div class="message ico_comment_upSmall"></div>
            </li>
            <li>
              <div
                class="message-text" v-html="articleComment"
              ></div>
            </li>
          </ul>
        </div>
      </el-footer>
      <el-divider class="article-footer-divider"></el-divider>
    </div>
  </el-container>
</template>

<script>


export default {
  name: "articlecomponent",
  props: {
    articleId: Number,
    articleTitle: String,
    articleCategory: String,
    articleDate: String,
    articlePages: String,
    articleSearchTerm: String,
    articleComment: String,
    articleImage: String,
    articleDataSection: Number
  },
  data() {
    return {
      visibleArrow: {
        default: false
      }
    };
  },
  methods: {
      
    }
};
</script>

<style scoped>
@import "../../assets/css/style.css";
.articleDiv {
  width: 100%;
}
.articleDiv .el-row {
  display: flex;
}
/* *************    hover focus svg icons        ************* */
.ico_pdf_upSmall {
  background: url("../../assets/image/ico_pdf_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_pdf_upSmall:hover {
  background: url("../../assets/image/ico_pdf_over.svg") no-repeat;
}

.ico_pdf_upSmall:focus {
  background: url("../../assets/image/ico_pdf_down.svg") no-repeat;
  outline: none;
}

.ico_csv-output_upSmall {
  background: url("../../assets/image/ico_csv-output_up.svg") no-repeat;
  width: 19.21px;
  height: 22px;
}

.ico_csv-output_upSmall:hover {
  background: url("../../assets/image/ico_csv-output_over.svg") no-repeat;
}

.ico_csv-output_upSmall:focus {
  background: url("../../assets/image/ico_csv-output_down.svg") no-repeat;
  outline: none;
}

.ico_text_upSmall {
  background: url("../../assets/image/ico_text_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_text_upSmall:hover {
  background: url("../../assets/image/ico_text_over.svg") no-repeat;
}
.ico_text_upSmall:focus {
  background: url("../../assets/image/ico_text_down.svg") no-repeat;
  outline: none;
}

.ico_print_upSmall {
  background: url("../../assets/image/ico_print_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_print_upSmall:hover {
  background: url("../../assets/image/ico_print_over.svg") no-repeat;
}
.ico_print_upSmall:focus {
  background: url("../../assets/image/ico_print_down.svg") no-repeat;
  outline: none;
}

.ico_comment_upSmall {
  background: url("../../assets/image/ico_comment_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  position: relative;
  top: 5px;
}

.commentRow {
  min-height: 26px;
}

#anim > div > div > div > span > section:nth-child(2) > div {
  background-color: var(--grayBackground);
}

.article-img img {
  width: 70px;
  padding-top: 3px;
}

.checkbox-list {
  padding: 8px 0px 8px 7px;
}
.articleNews {
  width: calc(100% - 60px);
  text-align: left;
}

.articleFirstLable {
  width: 70px;
}
.articleLabel label:nth-child(2) {
  padding-left: 0px;
  line-height: 35px;
  color: var(--grayDark2);
}
.header-article {
  height: 45px !important;
  display: contents;
}

.el-main {
  overflow: hidden !important;
  padding: 0px !important;
}

.article-main-divider {
  margin: 0px !important;
  background: var(--grayLight2) !important;
}

.article-footer-divider {
  margin: 0px !important;
  background: #a2a4aa !important;
}

.article-top {
  font-size: 10.4pt;
  font-weight: bold;
  padding-right: 20px;
  color: var(--link);
  cursor: pointer;
  display: block;
  margin-top: 9px;
  line-height: 22px;
  margin-left: 8px;
}

.article-top:focus {
  color: var(--visited);
  outline: none;
}

.article-top:hover {
  color: #660099;
}

.article-middle {
  padding: 0px;
  margin: 0px auto;
  padding-left: 45px;
}

.el-footer {
  height: auto !important;
}

.article-list ul {
  padding: 0px;
  margin: 6px auto;
}

.article-list ul li {
      list-style: inside;
    font-size: 8pt;
    padding-right: 8px;
    color: var(--grayDark2);
    cursor: pointer;
        line-height: 1.1;
}

.article-right ul {
  padding: 0px;
  margin: 8px auto;
}

.article-right ul li {
  list-style: none;
  float: right;
  padding-left: 12px;
  color: #0097e0;
  padding-top: 5px;
  padding-bottom: 5px;
}

.article-right ul li img {
  width: 15px;
  margin-top: -1px;
}

.message {
  float: right;
  font-size: 20px;
  color: #0097e0;
  line-height: 28px;
  display: block;
  margin-right: 5px;
}

.message img {
  width: 24px;
  margin-left: 15px;
}

.message-text {
  font-size: 8pt;
  color: var(--grayDark2);
  display: block;
  display: block;
  position: relative;
  -webkit-transform: translateY(4px);
  transform: translateY(-50%);
  margin-bottom: 0px;
  top: 50%;
}

.tooltip-image img {
  height: 90px;
  padding: 5px;
}

.commentRow ul {
  padding: 0px;
  margin: 0px auto;
  margin-left: 68px;
  list-style: none;
}

.commentRow ul li {
  float: left;
}

.commentRow ul li:last-child {
  float: right;
}
.ariticle-bottom {
  display: flex;
}
.ariticle-bottom ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  width: 100%;
  margin-left: 50px;
}

.ariticle-bottom ul li {
  float: left;
}

.article-img {
  line-height: 25px;
  text-align: left;
}

.list-first-div {
  width: 60px;
}

.list-first-div div {
  display: inline-block;
}

.article-list ul li:first-child {
  padding-left: 0px !important;
}

.articleSpec {
  display: inline-block !important;
  margin-left: 0px !important;
}
.articleSpec li {
  float: left !important;
  padding-top: 10px;
}
.iconUl {
  margin-left: 0px !important;
  float: right;
}
.article-first-child {
  width: 100px;
}
.article-second-child {
  width: calc(100% - 265px);
  text-align: left;
}
.article-third-child {
  width: 157px;
  position: absolute;
  right: 0;
  top: -5px;
}
.article-right ul li:last-child {
  padding-right: 10px;
}

.article-right ul li:first-child {
  padding-left: 0px;
}

#SearchArticleDiv .article-top {
      margin-top: 0px;
      font-size: 10.4pt;
}
#SearchArticleDiv .articleRow {
  width: 100%;
      margin-top: 15px;
}
#SearchArticleDiv .logoArtInfo {
      margin-left: 75px;
}
#SearchArticleDiv .ariticle-bottom ul {
      margin-left: 55px;
}
#SearchArticleDiv .article-list ul li {
  font-size: 8pt;
  cursor: default;
}
#SearchArticleDiv .message-text {
  font-size: 8pt;
  text-align: left;
}
#SearchArticleDiv .article-footer-divider {
    margin: 0px !important;
    background: #959a9d !important;
}
.articleSpec li .articleSpan {
  display: inline-block;
    margin-left: -6px;
}
</style>